import { ApolloProvider } from "@apollo/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React from "react";

import { store } from "./redux/store";
import App from "./navigation/App";
import apolloClient from "./api/apolloClient";
import palette from "./redux/slices/theme";

function RootApp() {
  const theme = createTheme(palette);
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={apolloClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApolloProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default RootApp;
